export default "__VITE_ASSET__Bpb16kKf__"